import ApiService, { HTTPMethod } from "./api.core";
import { Transformer } from "../models/Transformer";
import { COI } from "../models/coi/coi.model";

class PolicyManagementCOIApi {

  async getPolicyCOIs(insuranceId) {
    let res = await ApiService.fetch(`certificates/all/${insuranceId}`)
    if(res.ok) {
      res.parsedData = res.data.certificates.map(coi => Transformer.initializeFromDataDeep(new COI(), coi))
    }
    return res
  }

  async getMeargedPolicyCOIs(insuranceId) {
    var res = await ApiService.fetch(`certificates/merged_coi/${insuranceId}`)
    return res
  }
  async getPolicyCOI(certificateId) {
    let res = await ApiService.fetch(`certificates/${certificateId}`)
    return res
  }
 //TODO: dont think this is in use
  async createNewCOI(insuranceId, aiIds) {
    let res = await ApiService.fetch(`certificates/${insuranceId}`, HTTPMethod.POST, {
      additional_insureds_ids: aiIds
    })
    return res
  }
 //TODO: dont think this is in use
  async deleteCOI(certificateId) {
    return await ApiService.fetch(`certificates/${certificateId}`, HTTPMethod.DELETE)
  }
}

export default new PolicyManagementCOIApi()